// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.WheelSentry.View'
    , [
        'PageType.Base.View',
        'eureka_maxatrendingproducts_wheel_sentry.tpl'
    ]
    , function (
        PageTypeBaseView,
        eureka_maxatrendingproducts_wheel_sentry_tpl
    ) {
        'use strict';

        // @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxatrendingproducts_wheel_sentry_tpl

            , initialize: function (options) {

            }

            , beforeShowContent: function beforeShowContent() {
                this.getBreadcrumbPages = function () {
                    return [{
                        text: 'Wheel Sentry',
                        href: ''
                    }];
                };

                return jQuery.Deferred().resolve()


            }

            //@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
            , getContext: function getContext() {
                return {};
            }
        });
    });
